/* eslint-disable no-restricted-globals, import/no-mutable-exports */

import { boolean } from 'boolean';
import UAParser from 'ua-parser-js';

import queryString from 'query-string';

const parser = new UAParser();

parser.setUA(navigator.userAgent);


const PARSED_CONFIG = queryString.parse(location.search);

export const DEBUG = boolean(PARSED_CONFIG.debug);

export const CONTROLS = false;

export const FORCE_SPECULAR = boolean(PARSED_CONFIG.specular);

export const FORCE_LIGHT_RTN = boolean(PARSED_CONFIG.lightrotation);

export const STATS = boolean(PARSED_CONFIG.stats);

export const DPI = Math.min(window.devicePixelRatio, 2);

export const JSON_DATA = {};

export let CONTAINER = null;

export const SET_CONTAINER = (val) => {
  CONTAINER = val;
};


export let IS_SPECULAR = FORCE_SPECULAR;

export const SET_IS_SPECULAR = (val) => {
  IS_SPECULAR = val || FORCE_SPECULAR;
};

export let IS_LIGHT_RTN = FORCE_LIGHT_RTN;

export const SET_IS_LIGHT_RTN = (val) => {
  IS_LIGHT_RTN = val || FORCE_LIGHT_RTN;
};

export let ROTA_X = 0.0;

export let ROTA_Y = 0.0;

export let ROTA_Z = 0.0;

export const SET_ROTA_X = (val) => {
  ROTA_X = val;
};


export const SET_ROTA_Y = (val) => {
  ROTA_Y = val;
};


export const SET_ROTA_Z = (val) => {
  ROTA_Z = val;
};
